import { render } from "./CheckPrice.vue?vue&type=template&id=6cf3a180&scoped=true"
import script from "./CheckPrice.vue?vue&type=script&lang=js"
export * from "./CheckPrice.vue?vue&type=script&lang=js"

import "./CheckPrice.vue?vue&type=style&index=0&id=6cf3a180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf3a180"]])

export default __exports__